import React from 'react';
import { motion } from 'framer-motion';
export function MidPageCTA() {
  return <section className="bg-offwhite py-12 px-6" data-id="element-131">
      <div className="max-w-3xl mx-auto text-center" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-133">
          <a href="#offer" onClick={e => {
          e.preventDefault();
          document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-lg shadow-green-600/30 transition-all transform hover:scale-105 active:scale-95 w-full sm:w-auto border-b-4 border-green-800" data-id="element-134">
            QUIERO EL MANUAL (PDF)
          </a>
          <p className="text-sm text-slate-500 mt-4 font-medium" data-id="element-135">
            Ebook digital · Acceso inmediato · Pago único
          </p>
        </motion.div>
      </div>
    </section>;
}